import React, { Component } from 'react'
import './fileUploader.css';

import {
  CloudUploadOutlined,
} from '@ant-design/icons';

export default class FileUploaderAuto extends Component {
  state = {
    data: [],
    classHover: '',
    tipadoArchivo: false,
    extensiones: ['txt', 'doc', 'docx', 'xls', 'xlsx', 'xlsm', 'xlsb', 'xltx', 'ppt', 'pptx', 'pps', 'ppsx', 'pdf', 'jpeg', 'jpg', 'png'],
    textoExtensiones: '.txt, .doc, .docx, .xls, .xlsx, .xlsm, .xlsb, .xltx, .ppt, .pptx, .pps, .ppsx, .pdf, .jpeg, .jpg, .png',
    textoAux: 'archivos'
  }
    
  componentWillMount = () => {
    if (this.props.uploadFile === true) {
      this.setState({
        tipadoArchivo: true,
        textoExtensiones: '.xls, .xlsx',
        extensiones: ['xls', 'xlsx']
      })
    } else if (this.props.uploadImagen === true) {
      this.setState({
        tipadoArchivo: true,
        textoExtensiones: '.jpeg, .jpg, .png, .webp',
        extensiones: ['jpeg', 'jpg', 'png', 'webp']
      })
    }
  }
  dropHandler = (ev) => {
    let archivos = []
    let archivosErroneosExtension = []
    let archivosErroneosTamano = []
    let extensionEncontrada = false
    let tamanoCorrecto = false
    ev.preventDefault();
    this.setState({ classHover: '#d0d0d0' })
    if (ev.dataTransfer.items) {
      for (var i = 0; i < ev.dataTransfer.items.length; i++) {
        if (ev.dataTransfer.items[i].kind === 'file') {
          var file = ev.dataTransfer.items[i].getAsFile();
          var extension = file.name.split(".").pop().toLowerCase()
          let indexExt = this.state.extensiones.findIndex(ext => ext === extension)
          if (indexExt > -1) {
            extensionEncontrada = true
          } else {
            if (this.props.multi) {
              archivosErroneosExtension.push(file.name)
            } else {
              archivosErroneosExtension = [file.name];
            }
          }
          if (file.size <= (parseInt(this.props.tamanoArchivo)*1024*1024)) {
            tamanoCorrecto = true
          } else {
            if (this.props.multi) {
              archivosErroneosTamano.push(file.name)
            } else {
              archivosErroneosTamano = [file.name];
            }
          }
          if (tamanoCorrecto === true && extensionEncontrada === true) {
            if (this.props.multi) {
              archivos.push(file)
            } else {
              archivos = [file];
            }
          }
        }
      }
      let textoError = ""
      if (archivosErroneosExtension.length > 0) {
        textoError += "Los siguientes archivos no pasaron los filtros de extensión:<br> "
        for (let a = 0; a < archivosErroneosExtension.length; a++) {
          const archivo = archivosErroneosExtension[a];
          textoError += archivo + '<br>'
        }
      } 
      if (archivosErroneosTamano.length > 0) {
        textoError += "Los siguientes archivos no pasaron los filtros de tamaño:<br> "
        for (let a = 0; a < archivosErroneosTamano.length; a++) {
          const archivo = archivosErroneosTamano[a];
          textoError += archivo + '<br>'
        }
      } 
      if (textoError !== "") {
        textoError += "<br>Por favor cargue nuevamente los archivos excluyendo los anteriormente mencionados"
        this.props.openSwal(textoError, 0, "Error")
      }
      if (archivosErroneosExtension.length === 0 && archivosErroneosTamano.length === 0) {
        this.props.mostrarData(archivos)
      }
    }
  }

  dragOverHandler = (ev) => {
    this.setState({ classHover: '#1890ff' })
    ev.preventDefault();
  }

  clickHandler = (e) => {
    let archivos = []
    let archivosErroneosExtension = []
    let archivosErroneosTamano = []
    let extensionEncontrada = false
    let tamanoCorrecto = false
    const files = Array.from(e.target.files)
    for (var i = 0; i < files.length; i++) {
      var file = files[i]
      var extension = file.name.split(".").pop().toLowerCase()
      let indexExt = this.state.extensiones.findIndex(ext => ext === extension)
      if (indexExt > -1) {
        extensionEncontrada = true
      } else {
        if (this.props.multi) {
          archivosErroneosExtension.push(file.name)
        } else {
          archivosErroneosExtension = [file.name];
        }
      }
      if (file.size <= (parseInt(this.props.tamanoArchivo) * 1024 * 1024)) {
        tamanoCorrecto = true
      } else {
        if (this.props.multi) {
          archivosErroneosTamano.push(file.name)
        } else {
          archivosErroneosTamano = [file.name];
        }
      }
      if (tamanoCorrecto === true && extensionEncontrada === true) {
        if (this.props.multi) {
          archivos.push(file)
        } else {
          archivos = [file];
        }
      }
    }
    let textoError = ""
    if (archivosErroneosExtension.length > 0) {
      textoError += "Los siguientes archivos no pasaron los filtros de extensión:<br> "
      for (let a = 0; a < archivosErroneosExtension.length; a++) {
        const archivo = archivosErroneosExtension[a];
        textoError += archivo + '<br>'
      }
    }
    if (archivosErroneosTamano.length > 0) {
      textoError += "Los siguientes archivos no pasaron los filtros de tamaño:<br> "
      for (let a = 0; a < archivosErroneosTamano.length; a++) {
        const archivo = archivosErroneosTamano[a];
        textoError += archivo + '<br>'
      }
    }
    if (textoError !== "") {
      textoError += "<br>Por favor cargue nuevamente los archivos excluyendo los anteriormente mencionados"
      this.props.openSwal(textoError, 0, "Error")
    }
    if (archivosErroneosExtension.length === 0 && archivosErroneosTamano.length === 0) {
      this.props.mostrarData(archivos)
    }
  }

  render() {
    return (
      <div style={{width: '100%'}}>
        <div className="drop_zone" style={{ borderColor: this.state.classHover }} onDrop={(event) => this.dropHandler(event)} onDragOver={(event) => this.dragOverHandler(event)}>
          {/* <Icon type="inbox" style={{ color: '#1890ff', fontSize: '40px' }} /> */}
          <CloudUploadOutlined />
          <p>Da click o arrastra el archivo que deseas cargar</p>
          {
            this.props.multi ? <p>Soporta archivos {this.state.textoExtensiones}. Puede cargar múltiples {this.state.textoAux} a la vez</p> : <p>Soporta archivos {this.state.textoExtensiones}</p>
          }
          <input id="antilopeFileAutoInput" onChange={(e) => this.clickHandler(e)} className='fileClick' type="file" multiple={this.props.multi} />
        </div>
      </div>
    )
  }
}

